import { SectionCard } from "@/deps/ui-library";
import { Link } from "@tanstack/react-router";
import { useHelpCategory } from "@/api/queries";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { EmptyState } from "@/components/EmptyState";
import { HelpGate } from "./HelpGate";

/** One topic, and the guides in it this reader may open. */
export function HelpCategoryPage({ slug }: { slug: string }) {
  const category = useHelpCategory(slug);

  return (
    <HelpGate section="guides">
      <Breadcrumbs
        items={[{ label: "Guides", to: "/help" }, { label: category.data?.name ?? "Topic" }]}
      />
      {category.isError ? (
        <EmptyState
          icon="BookX"
          title="That topic is not available"
          description="It may have moved, or it may hold no guides you can open."
        />
      ) : null}
      {category.data ? (
        <SectionCard title={category.data.name} flush>
          <ul className="flex flex-col">
            {category.data.articles.map((article) => (
              <li key={article.id} className="border-border border-b last:border-0">
                <Link
                  to="/help/articles/$slug"
                  params={{ slug: article.slug }}
                  className="hover:bg-muted focus-visible:ring-ring flex flex-col px-4 py-2.5 no-underline focus-visible:ring-2 focus-visible:outline-none focus-visible:ring-inset"
                >
                  <span className="text-foreground text-sm">{article.title}</span>
                  {article.summary ? (
                    <span className="text-muted-foreground text-xs">{article.summary}</span>
                  ) : null}
                </Link>
              </li>
            ))}
          </ul>
        </SectionCard>
      ) : null}
    </HelpGate>
  );
}
